<script>
export default {
  name: 'GiantCta',

  mounted() {
    this.addTrackingDataToRegisterButton({
      element: this.$el.querySelector('a.moqo_link'),
      section: 'giant-cta'
    })
  },
}
</script>

<template>
  <div>
    <mq-call-to-action v-if="teamsiteConfig" :action="{ text: signupBtnText, url: routes.signUpUrl }" :color="teamsiteConfig.color">
      <h1 class="cta">
        {{ $t('teamsite.call_to_action.title') }}
      </h1>
    </mq-call-to-action>

    <slot name="post-cta-section"></slot>
  </div>
</template>

<style lang="scss" scoped>
.cta {
  color: $black;
  font-size: rem-calc(60);
  @include breakpoint(small only) {
    font-size: rem-calc(40);
    line-height: rem-calc(60);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/GiantCta.vue